import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input } from '@angular/core';
import { CriteoData } from '@common/interfaces';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

/**
 * 予約・購入完了 criteoデータ
 */
@Component({
  selector: 'asw-booking-completed-criteo',
  templateUrl: './booking-completed-criteo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingCompletedCriteoComponent extends SupportComponent {
  /** criteoデータ */
  @Input()
  set criteo(value: CriteoData) {
    this._criteo = value;
    this.change.markForCheck();
  }
  get criteo(): CriteoData {
    return this._criteo;
  }

  private _criteo: CriteoData = {
    segmentCode: '',
    deviceType: '',
    departureDate: '',
    arrivalDate: '',
    connectionKind: '',
    languageCode: '',
    searchMode: '',
    adultCount: 0,
    childCount: 0,
    infantCount: 0,
    boardingClass: '',
    boardingClassOption: '',
    totalAmount: 0,
    transactionId: '',
    customerType: '',
  };

  constructor(private _common: CommonLibService, public change: ChangeDetectorRef) {
    super(_common);
  }
  /** 画面初期化処理 */
  init() {}

  /** 画面終了時処理 */
  destroy() {}

  /** 画面更新時処理 */
  reload() {}
}
